import { css } from 'emotion'

export const TaskTagsMainStyles = css`
  
`
